<template>
<div style="margin-top:-8px;margin-left:-8px">
    <div class="starrySky">
        <canvas id="canvas"></canvas>
    </div>
    <div class="login">
        <img width="100%" src="../assets/logo5.png">
        <div class="divv">
            <el-input
                placeholder="账号"
                prefix-icon="el-icon-user"
                v-model="account" clearable>
            </el-input>
        </div>
        <div class="divv">
            <el-input
                placeholder="密码"
                prefix-icon="el-icon-key"
                v-model="password"  show-password clearable>
            </el-input>
        </div>
        <div class="divv">
              <el-button  @click="login" style="width:100%" type="primary">登录</el-button>
        </div>
    </div>

</div>
</template>

<script>
import { loging } from '@/request.js'
import { startaction} from '@/loginAnimate.js'
export default {
    data() {
        return {
            account:"",
            password:"",
        };
    },
    created(){
       
    },
    mounted(){
        startaction();
        localStorage.setItem("loadjsover","1");
        var token= localStorage.getItem("usertoken");
        if(token!=undefined){
            this.$router.push({
                path: `/index`,
            })
        }
    },
    methods:{
        login(){
            if(this.account==""){
                this.$message({
                    message: '请填写账号',
                    type: 'warning'
                });
                return;
            }
            if(this.password==""){
                this.$message({
                    message: '请填写密码',
                    type: 'warning'
                });
                return;
            }
            loging({account:this.account,password:this.password},(res)=>{
                if(res.IsSuccess){
                    localStorage.setItem("usertoken",res.Message);
                    localStorage.setItem("manger",JSON.stringify(res.Result));
                    window.location.reload();
                }else{
                    this.$message.error(res.Message);
                }
            });
        },
    },
}

</script>
<style scoped>
.starrySky {position: fixed;height:100%;width:100%;margin: 0;overflow: hidden;width: 100%;cursor: none;background: black;background: linear-gradient(to bottom,#000000 0%,#5788fe 100%);}
.login{position:absolute;left: 40%;top: 20%;width: 20%;}
.divv{margin-top: 20px;}

</style>
<style>

/* html, body {height: 100%;overflow: hidden;margin: 0px;} */

</style>